export default function HolidayItem(props) {
  return(
    <li>
      {props.text}
      <hr/>
    </li>
  )
}